//NOTE: This makes sure the component can be rendered by the browser
export * from "./components/GameCanvas";
export * from "./components/StartCanvas";
export * from "./components/minigames/dragonInvaders/components/game-board";
export * from "./components/minigames/dragonInvaders/components/player-wizard";
export * from "./components/minigames/dragonInvaders/components/enemy-dragon";
export * from "./components/minigames/dragonInvaders/components/projectile";


function setup(): void {
    const gameStarted: string | null = localStorage.getItem("game-started");
    const startdragonInvaders: string | null = localStorage.getItem("start-dragon-invaders");


    if (!gameStarted && !startdragonInvaders) {
        document.body.innerHTML = "<start-canvas></start-canvas>";
    }

    if (gameStarted && !startdragonInvaders) {
        document.body.innerHTML = "<game-canvas></game-canvas>";
    }

    if (startdragonInvaders) {
        document.body.innerHTML = "<game-board></game-board>";
    }
}

setup();